<section class="transactions-page">
  <app-admin-page-header [title]="title" [subtitle]="subtitle">
    <div header-actions class="transactions-page__meta">
      <button *ngIf="canCreateAdminTransaction" type="button" class="admin-btn admin-btn--primary"
        routerLink="/dashboard/transactions/nova">
        Criar transação
      </button>
      <button *ngIf="returnToTransactionId != null" type="button" class="admin-btn admin-btn--secondary"
        (click)="goBackToTransactionDetail()">
        Voltar ao detalhe da transação
      </button>
      <span>{{ totalItems }} Transações</span>
    </div>
  </app-admin-page-header>

  <div class="transactions-toolbar admin-surface">
    <div class="transactions-toolbar__fields">
      <div class="transactions-toolbar__field">
        <label for="status">Status</label>
        <select id="status" class="admin-input" [(ngModel)]="statusFilter">
          <option *ngFor="let option of statusOptions" [value]="option.value">
            {{ option.label }}
          </option>
        </select>
      </div>

      <div class="transactions-toolbar__field transactions-toolbar__field--type">
        <label for="transaction-type">Tipo</label>
        <select id="transaction-type" class="admin-input" [(ngModel)]="typeFilter">
          <option *ngFor="let option of typeOptions" [value]="option.value">
            {{ option.label }}
          </option>
        </select>
      </div>

      <div class="transactions-toolbar__field">
        <label for="user-search">Username ou ID</label>
        <input id="user-search" type="text" class="admin-input" [(ngModel)]="searchTerm"
          (keydown.enter)="onApplyFilters()" placeholder="Ex.: player101 ou 103" />
      </div>

      <div class="transactions-toolbar__field">
        <label for="trusted-filter">Trusted</label>
        <select id="trusted-filter" class="admin-input" [(ngModel)]="trustedFilter">
          <option *ngFor="let option of trustedOptions" [value]="option.value">
            {{ option.label }}
          </option>
        </select>
      </div>

      <div class="transactions-toolbar__field">
        <label for="risk-filter">Risco</label>
        <select id="risk-filter" class="admin-input" [(ngModel)]="riskFilter">
          <option *ngFor="let option of riskOptions" [value]="option.value">
            {{ option.label }}
          </option>
        </select>
      </div>
      <div class="transactions-toolbar__field">
        <label for="start-date">Data inicial</label>
        <p-datepicker inputId="start-date" dateFormat="dd/mm/yy" [(ngModel)]="startDate" [readonlyInput]="true"
          placeholder="Selecione..." styleClass="admin-input-date" appendTo="body"> </p-datepicker>
      </div>

      <div class="transactions-toolbar__field">
        <label for="end-date">Data final</label>
        <p-datepicker inputId="end-date" dateFormat="dd/mm/yy" [(ngModel)]="endDate" [readonlyInput]="true"
          placeholder="Selecione..." styleClass="admin-input-date" appendTo="body"> </p-datepicker>
      </div>
    </div>

    <footer class="transactions-toolbar__footer">
      <div class="transactions-toolbar__group">
        <span class="transactions-toolbar__group-label">Filtros na listagem</span>
        <div class="transactions-toolbar__buttons" role="group" aria-label="Ações de filtro">
          <button class="admin-btn admin-btn--primary" type="button" (click)="onApplyFilters()">
            Aplicar filtros
          </button>
          <button class="admin-btn admin-btn--secondary" type="button" (click)="clearFilters()">
            Limpar
          </button>
        </div>
      </div>
      <div class="transactions-toolbar__group transactions-toolbar__group--export">
        <div class="transactions-toolbar__buttons" role="group" aria-label="Exportar dados">
          <button class="admin-btn admin-btn--success" type="button" (click)="exportCsv()"
            [disabled]="isLoading || isExporting"
            title="Exportar todas as linhas que batem com os filtros (não só esta página)">
            <i class="pi pi-download" aria-hidden="true"></i>
            {{ isExporting ? 'Exportando…' : 'Exportar CSV' }}
          </button>
        </div>
      </div>
    </footer>
  </div>

  <div class="transactions-table-wrapper admin-surface">
    <p-table [value]="rows" [paginator]="true" [rows]="rowsPerPage" [first]="tableFirst" [totalRecords]="totalItems"
      [lazy]="true" [lazyLoadOnInit]="false" [loading]="isLoading" [showLoader]="false"
      (onLazyLoad)="onLazyLoad($event)">
      <ng-template pTemplate="header">
        <tr>
          <th>ID da transação</th>
          <th>Usuário (ID)</th>
          <th>Valor</th>
          <th>Tipo</th>
          <th>Status</th>
          <th>Trusted</th>
          <th>Risco</th>
          <th>Data</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-transaction>
        <tr class="transactions-table__row--clickable" (click)="onTransactionRowClick(transaction, $event)"
          (keydown.enter)="onTransactionRowActivate(transaction)" tabindex="0" role="button"
          [attr.aria-label]="'Ver detalhe da transação ' + (transaction.id ?? '')">
          <td>{{ transaction.id || '-' }}</td>
          <td>{{ getUserDisplay(transaction) }}</td>
          <td>{{ transaction.amount ?? transaction.quantity ?? '-' }}</td>
          <td>{{ resolveTransactionTypeLabel(transaction) }}</td>
          <td>{{ transaction.status_display || getStatusLabel(transaction.status) }}</td>
          <td>
            <span *ngIf="transaction.is_trusted === true"
              class="transactions-badge transactions-badge--trusted">Sim</span>
            <span *ngIf="transaction.is_trusted === false" class="transactions-badge">Não</span>
            <span *ngIf="transaction.is_trusted !== true && transaction.is_trusted !== false">—</span>
          </td>
          <td class="transactions-col-risk">
            <span *ngIf="rowHasRisk(transaction)" class="transactions-risk-x"
              [title]="riskTooltip(transaction)">✕</span>
            <span *ngIf="!rowHasRisk(transaction)" class="transactions-risk-ok" title="Sem risco na conta">✓</span>
          </td>
          <td>{{ formatCreatedAtForTable(transaction.created_at) }}</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8" class="transactions-table__empty-message">
            <div *ngIf="isLoading" class="transactions-empty-state">
              <p-progressSpinner ariaLabel="Carregando transações" strokeWidth="6"></p-progressSpinner>
              <span>Carregando transações...</span>
            </div>
            <div *ngIf="!isLoading" class="transactions-empty-state">
              <i class="pi pi-wallet"></i>
              <span>Nenhuma transação encontrada para os filtros atuais.</span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <p class="transactions-error" *ngIf="errorMessage">{{ errorMessage }}</p>
</section>